// extracted by mini-css-extract-plugin
export default {"suggestedCaseStudiesWrapper":"suggestedCaseStudies-module--suggested-case-studies-wrapper--732e0"};